import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AtSign } from "lucide-react";
import { toast } from "sonner";

export default function AccountEmail() {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  if (!user || user.role !== "student") return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!email.toLowerCase().trim().endsWith("@essex.ac.uk")) { toast.error("Use your University of Essex address (ending @essex.ac.uk)"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-email", { new_email: email, current_password: pw });
      if (data.access_token) localStorage.setItem("weave_token", data.access_token);
      setUser({ ...user, email: data.email });
      toast.success(`Login email changed to ${data.email}`);
      setOpen(false); setEmail(""); setPw("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change email");
    } finally { setBusy(false); }
  };

  return (
    <div className="border border-[#E5E7EB] bg-white p-4 flex items-center gap-4 flex-wrap" data-testid="account-email">
      <AtSign size={18} className="text-[#25AAAA]" />
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-semibold">Login email</div>
        <div className="text-xs text-[#525252] font-mono" data-testid="account-email-current">{user.email}</div>
      </div>
      <button onClick={() => setOpen(true)} className="text-xs font-semibold underline text-[#0F1F2E] hover:text-[#25AAAA]" data-testid="account-email-change">
        Change email
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-none" data-testid="account-email-dialog">
          <DialogHeader>
            <DialogTitle>Change your login email</DialogTitle>
            <DialogDescription>Switched to a personalised Essex address? Enter it here — it must still end in @essex.ac.uk. Programme emails will go to the new address from now on.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <Input type="email" placeholder="firstname.surname@essex.ac.uk" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-none" data-testid="account-email-new" />
            <Input type="password" placeholder="Your current password" value={pw} onChange={(e) => setPw(e.target.value)} required className="rounded-none" data-testid="account-email-password" />
            <div className="flex justify-end gap-2">
              <Button type="button" variant="ghost" onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" disabled={busy} className="rounded-none bg-[#0F1F2E] hover:bg-[#1a2f42]" data-testid="account-email-submit">{busy ? "Saving…" : "Change email"}</Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
}
